export const SET_MAINTENANCE_MODE_ENABLED = 'SET_MAINTENANCE_MODE_ENABLED'
export const SET_STATUS_PENDING = 'SET_STATUS_PENDING'
export const SET_STATUS_ERROR = 'SET_STATUS_ERROR'
export const SET_RETRY_AT = 'SET_RETRY_AT'
